export default __webpack_public_path__ + "static/media/icon.9c477d78.svg";